/**
 * Date Filter Component
 * Handles form submission for blog date filtering using tags
 * Preserves existing tags and combines them with + character
 */

class DateFilter extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.select = this.querySelector('select');

    if (this.form && this.select) {
      this.init();
    }
  }

  getCurrentTags() {
    // Extract current tags from URL
    const match = window.location.pathname.match(/\/tagged\/([^/]+)/);
    if (!match) return [];

    // Split by + to get individual tags
    return match[1].split('+').filter((tag) => tag);
  }

  getBaseBlogUrl() {
    // Get blog URL without any tags
    return this.dataset.blogUrl || window.location.pathname.split('/tagged/')[0];
  }

  removeDateTags(tags) {
    // Remove existing date tags (yyyy-mm or yyyy format)
    return tags.filter((tag) => !tag.match(/^\d{4}(-\d{2})?$/));
  }

  init() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      const selectedValue = this.select.value;
      const blogUrl = this.getBaseBlogUrl();
      const currentTags = this.getCurrentTags();

      // Remove any existing date tags from current tags
      const nonDateTags = this.removeDateTags(currentTags);

      if (!selectedValue) {
        // If "All dates" is selected, keep non-date tags only
        if (nonDateTags.length > 0) {
          window.location.href = `${blogUrl}/tagged/${nonDateTags.join('+')}`;
        } else {
          window.location.href = blogUrl;
        }
        return;
      }

      // Combine non-date tags with new date tag
      const allTags = [...nonDateTags, selectedValue];
      window.location.href = `${blogUrl}/tagged/${allTags.join('+')}`;
    });

    // Optional: Auto-submit on select change (uncomment if desired)
    // this.select.addEventListener('change', () => {
    //   this.form.requestSubmit();
    // });
  }
}

// Initialize when DOM is ready
if (!customElements.get('date-filter')) {
  customElements.define('date-filter', DateFilter);
}

// Fallback for non-custom-element browsers
document.addEventListener('DOMContentLoaded', () => {
  const dateFilters = document.querySelectorAll('.date-filter');

  dateFilters.forEach((filter) => {
    const form = filter.querySelector('form');
    const select = filter.querySelector('select');

    if (!form || !select) return;

    const getCurrentTags = () => {
      const match = window.location.pathname.match(/\/tagged\/([^/]+)/);
      if (!match) return [];
      return match[1].split('+').filter((tag) => tag);
    };

    const removeDateTags = (tags) => {
      return tags.filter((tag) => !tag.match(/^\d{4}(-\d{2})?$/));
    };

    const blogUrl = form.dataset.blogUrl || window.location.pathname.split('/tagged/')[0];

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const selectedValue = select.value;
      const currentTags = getCurrentTags();
      const nonDateTags = removeDateTags(currentTags);

      if (!selectedValue) {
        // Navigate with non-date tags only
        if (nonDateTags.length > 0) {
          window.location.href = `${blogUrl}/tagged/${nonDateTags.join('+')}`;
        } else {
          window.location.href = blogUrl;
        }
        return;
      }

      // Combine non-date tags with new date tag
      const allTags = [...nonDateTags, selectedValue];
      window.location.href = `${blogUrl}/tagged/${allTags.join('+')}`;
    });
  });
});
